// extracted by mini-css-extract-plugin
export default {"cardsContainer":"OceanPlanContainer_cardsContainer__y6rPb"};